import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { ClerkProvider, useAuth, useUser } from '@clerk/clerk-react'
import { ThemeProvider } from "@/components/theme/theme-provider"
import App from './App.tsx'
import '@/styles/index.css'
import { dark } from '@clerk/themes'
import api from './services/api'

// Create a new component for user sync
function UserSync() {
  const { getToken } = useAuth();
  const { user } = useUser();

  React.useEffect(() => {
    const syncUser = async () => {
      try {
        const token = await getToken();
        if (token && user) {
          await api.post('/api/v1/users/sync', {
            external_id: user.id,
            username: user.username,
            first_name: user.firstName
          });
        }
      } catch (error) {
        console.error('Error syncing user:', error);
      }
    };

    syncUser();
  }, [getToken, user]);

  return null; // This component doesn't render anything
}

function Root() {
  const navigate = useNavigate();
  const isDev = import.meta.env.DEV;

  return (
    <ClerkProvider 
      publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}
      routerPush={(to: string) => navigate(to)}
      routerReplace={(to: string) => navigate(to, { replace: true })}
      appearance={{
        baseTheme: dark,
      }}
      signInUrl={isDev ? "/sign-in" : "https://accounts.app.dekk.me/sign-in"}
      signUpUrl={isDev ? "/sign-up" : "https://accounts.app.dekk.me/sign-up"}
      afterSignInUrl="/"
      afterSignUpUrl="/"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
    >
      <ThemeProvider>
        <UserSync />
        <App />
      </ThemeProvider>
    </ClerkProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>,
) 